module.exports = __webpack_public_path__ + "static/media/stofferingen-47.efc07033.jpg";